module.exports = {"510114001":"大丰街道","510114003":"三河街道","510114004":"新都街道","510114005":"新繁街道","510114006":"石板滩街道","510114007":"斑竹园街道","510114008":"桂湖街道","510114109":"清流镇","510114116":"军屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510114.json
// module id = 2389
// module chunks = 0